var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.351267,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    stroke: "#E2E2EA",
    strokeWidth: 0.659565
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_22541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8695 16.0515C12.5869 16.0515 11.5566 15.0212 11.5566 13.7386C11.5566 12.4561 12.5869 11.4258 13.8695 11.4258C15.1521 11.4258 16.1824 12.4561 16.1824 13.7386C16.1824 15.0212 15.1521 16.0515 13.8695 16.0515ZM13.8695 12.4771C13.1756 12.4771 12.6079 13.0448 12.6079 13.7386C12.6079 14.4325 13.1756 15.0002 13.8695 15.0002C14.5634 15.0002 15.1311 14.4325 15.1311 13.7386C15.1311 13.0448 14.5634 12.4771 13.8695 12.4771Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8681 20.5103C13.4266 20.5103 12.985 20.3421 12.6486 20.0057L10.1255 17.4826C8.06494 15.422 8.06494 12.0579 10.1255 9.99733C11.1347 8.98808 12.4594 8.44141 13.8681 8.44141C15.2769 8.44141 16.6015 8.98808 17.6107 9.99733C19.6713 12.0579 19.6713 15.422 17.6107 17.4826L15.0876 20.0057C14.7512 20.3421 14.3097 20.5103 13.8681 20.5103ZM13.8681 9.4927C12.7748 9.4927 11.7024 9.91322 10.8614 10.7332C9.20034 12.3943 9.20034 15.0856 10.8614 16.7256L13.3845 19.2488C13.6368 19.5011 14.0573 19.5011 14.3307 19.2488L16.8538 16.7256C18.5149 15.0646 18.5149 12.3733 16.8538 10.7332C16.0338 9.91322 14.9615 9.4927 13.8681 9.4927Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_22541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2977,
    height: 14.2977,
    fill: "white",
    transform: "translate(6.7207 7.17969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8648aff86ebf72afddb392a4a2aabb81.svg";
export { ForwardRef as ReactComponent };